import React, {Fragment, useEffect, useState} from "react";
import {Col, Form, Row, Select, Input} from "antd";
import {FormattedMessage} from "react-intl";
import {
  Video,
  VideoContentStatus,
  VideoContentTypeOptions
} from "@models/video-content";
import VideoSelection from "@components/video-contents/Selection";
import {SelectionMode} from "@models";
import {Image} from "@models/image";
import ImagePickerModal from "@components/custom/imagePicker/Modal";

const {Option} = Select;

interface SliderProps {
  selectedVideo: Video | null;
  selectedImage: Image | null;
}

const FranchiseItem: React.FC<SliderProps> = props => {
  const {form, item} = props;
  const [image, setImage] = useState(item?.image_file && typeof item?.image_file === 'string' ? JSON.parse(item?.image_file) : item?.image_file);
  const [video, setVideo] = useState(item?.video_content && typeof item?.video_content === 'string' ? JSON.parse(item?.video_content) : item?.video_content);
  const [videoType, setVideoContentType] = useState(item?.content_type);

  const onChangeType = type => {
    setVideoContentType(type);
    setVideo(null);
  };

  const onSelectVideo = (video: Video) => {
    setVideo(video);
    form.setFieldsValue({
      content_id: video.id,
      video_content: JSON.stringify(video)
    });
  };

  const onSelectImage = (image: Image) => {
    setImage(image);
    form.setFieldsValue({
      image_id: image.id,
      image_path: image.path,
      image_file: JSON.stringify(image)
    });
  };

  return (
    <Fragment>
      <Row gutter={24}>

        <Col span={12}>
          <Form.Item
            label={<FormattedMessage id="app.type" defaultMessage={`Type`}/>}
          >
            {form.getFieldDecorator("content_type", {
              initialValue: item?.content_type
            })(
              <Select onChange={onChangeType}>
                {VideoContentTypeOptions.map((opt, index) => (
                  <Option key={index} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={
              <FormattedMessage
                id="app.select_video"
                defaultMessage={`Select Video`}
              />
            }
          >
            {form.getFieldDecorator("content_id", {
              initialValue: video?.id,
              rules: [
                {
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.video_is_required"
                      defaultMessage={`Select video!`}
                    />
                  )
                }
              ]
            })(<Input type={`hidden`}/>)}
            <VideoSelection
              key={videoType}
              filter={{
                video_content_type: videoType,
                status: VideoContentStatus.ACTIVE
              }}
              disabled={videoType ? false : true}
              mode={SelectionMode.DEFAULT}
              onChange={onSelectVideo}
              initialValue={video}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24} className={`video-poster-wrapper`}>
        <Col span={24}>
          <Form.Item className={"no-label"}>
            {form.getFieldDecorator("image_path", )(
             <Input type={"hidden"}/>
            )}
          </Form.Item>
          <Form.Item className={"no-label"}>
            {form.getFieldDecorator("image_id", {
              initialValue: image?.id,
              rules: [
                {
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.image_is_required"
                      defaultMessage={`image is required!`}
                    />
                  )
                }
              ]
            })(
              <ImagePickerModal
                onSelectImage={onSelectImage}
                selectedImage={image}
              >
                <div
                  className={`image-wrapper`}
                  style={{backgroundImage: `url(${image ? image.path : item?.image_path })`}}
                >
                  <FormattedMessage
                    id="app.select_image"
                    defaultMessage={`Select image`}
                  />
                </div>
              </ImagePickerModal>
            )}
          </Form.Item>
        </Col>
      </Row>
    </Fragment>
  );
};

export default FranchiseItem;
